import { GzGeneralNotificationsWebComponent } from './component/GzGeneralNotificationsWebComponent';

export { GzGeneralNotificationsWebComponent };
